import * as React from 'react';
import { Tab as Tab$1 } from '@headlessui/react';
import clsx from 'clsx';

/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

function styleInject(css, ref) {
  if (ref === void 0) ref = {};
  var insertAt = ref.insertAt;

  if (!css || typeof document === 'undefined') {
    return;
  }

  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.type = 'text/css';

  if (insertAt === 'top') {
    if (head.firstChild) {
      head.insertBefore(style, head.firstChild);
    } else {
      head.appendChild(style);
    }
  } else {
    head.appendChild(style);
  }

  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
}

var css_248z = ".Tabs-module_tabs__3DBjP{display:flex;flex-direction:column}.Tabs-module_tabs__3DBjP.Tabs-module_isFitted__5ZgdQ .Tabs-module_tab__HKjf4{flex:1;text-align:center}.Tabs-module_tabs__3DBjP:not(.Tabs-module_isFitted__5ZgdQ) .Tabs-module_tabList__tWg_y{overflow-x:auto;-webkit-overflow-scrolling:touch}.Tabs-module_tabList__tWg_y{display:flex;flex-shrink:0;border:0;max-height:56px;height:56px;overflow-y:hidden}.Tabs-module_tabList__tWg_y>*+*{margin-left:1rem}.Tabs-module_tabList__tWg_y::-webkit-scrollbar{display:none}.Tabs-module_withBorder__2RVBD{border-bottom:1px solid var(--color-border-subdued)}.Tabs-module_tab__HKjf4{--tab-default-font-weight:var(--component-tabs-default-font-weight,var(--font-weight-action));background:none;border:none;font:inherit;cursor:pointer;font-weight:var(--tab-default-font-weight);font-size:var(--size-font-action);line-height:var(--size-line-height-text-action);flex-shrink:0;padding:12px 0;color:var(--color-text-default);-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;position:relative;border-radius:.5rem;outline:none}.Tabs-module_tab__HKjf4>.Tabs-module_content__Y1WLn{display:flex;align-items:center;justify-content:center;padding:4px 8px;border-radius:8px}.Tabs-module_tab__HKjf4 .Tabs-module_content__Y1WLn>*+*{margin-left:8px}.Tabs-module_tab__HKjf4:hover{cursor:pointer}.Tabs-module_tab__HKjf4.Tabs-module_selected__ojAqF{--tab-selected-font-weight:var(--component-tabs-selected-font-weight,var(--font-weight-action));position:relative;color:var(--color-text-default);font-weight:var(--tab-selected-font-weight);font-size:var(--size-font-action);line-height:var(--size-line-height-text-action)}.Tabs-module_tab__HKjf4.Tabs-module_selected__ojAqF i,.Tabs-module_tab__HKjf4.Tabs-module_selected__ojAqF svg{color:var(--color-icon-informational)}.Tabs-module_tab__HKjf4:after{content:\"\";height:0;bottom:0;left:0;right:0;position:absolute;border-color:currentcolor transparent transparent;border-top:.25rem solid transparent;border-top-right-radius:24px;border-top-left-radius:24px}.Tabs-module_tab__HKjf4.Tabs-module_disabled__3I7hW,.Tabs-module_tab__HKjf4.Tabs-module_disabled__3I7hW i,.Tabs-module_tab__HKjf4.Tabs-module_disabled__3I7hW svg{color:var(--color-text-disabled);cursor:not-allowed}.Tabs-module_tab__HKjf4:not(.Tabs-module_disabled__3I7hW,:active,.Tabs-module_selected__ojAqF):focus-visible .Tabs-module_content__Y1WLn{box-shadow:inset 0 0 0 2px var(--color-action-default);transition:box-shadow .1s ease}.Tabs-module_tab__HKjf4:not(.Tabs-module_disabled__3I7hW):active .Tabs-module_content__Y1WLn{background-color:var(--color-surface-pressed)!important}.Tabs-module_tab__HKjf4:not(.Tabs-module_disabled__3I7hW):hover .Tabs-module_content__Y1WLn{background-color:var(--color-surface-hovered)}.Tabs-module_tab__HKjf4:not(.Tabs-module_disabled__3I7hW).Tabs-module_selected__ojAqF:after{border-color:var(--color-action-default)}.Tabs-module_tabsContent__3Tz20{flex-grow:1;padding:20px}";
var styles = {"tabs":"Tabs-module_tabs__3DBjP","isFitted":"Tabs-module_isFitted__5ZgdQ","tab":"Tabs-module_tab__HKjf4","tabList":"Tabs-module_tabList__tWg_y","withBorder":"Tabs-module_withBorder__2RVBD","content":"Tabs-module_content__Y1WLn","selected":"Tabs-module_selected__ojAqF","disabled":"Tabs-module_disabled__3I7hW","tabsContent":"Tabs-module_tabsContent__3Tz20"};
styleInject(css_248z);

/**
 * Creates a named context, provider, and hook.
 *
 * @param options create context options
 */

function createContext(options) {
  if (options === void 0) {
    options = {};
  }

  var _a = options.strict,
      strict = _a === void 0 ? true : _a,
      _b = options.errorMessage,
      errorMessage = _b === void 0 ? 'useContext: `context` is undefined. Seems you forgot to wrap component within the Provider' : _b,
      name = options.name;
  var Context = /*#__PURE__*/React.createContext(undefined);
  Context.displayName = name;

  function useContext() {
    var _a;

    var context = React.useContext(Context);

    if (!context && strict) {
      var error = new Error(errorMessage);
      error.name = 'ContextError';
      (_a = Error.captureStackTrace) === null || _a === void 0 ? void 0 : _a.call(Error, error, useContext);
      throw error;
    }

    return context;
  }

  return [Context.Provider, useContext, Context];
}

var _a;
var TabsContextProvider = (_a = createContext(), _a[0]), useTabsContext = _a[1];

var Tab = React.forwardRef(function (props, ref) {
    var className = props.className, disabled = props.disabled, tabProps = __rest(props, ["className", "disabled"]);
    return (React.createElement(Tab$1, __assign({ ref: ref, disabled: disabled, className: function (_a) {
            var selected = _a.selected;
            return clsx(styles.tab, selected && styles.selected, disabled && styles.disabled, className);
        } }, tabProps), function (_a) {
        var selected = _a.selected;
        return React.createElement(TabContent, { selected: selected }, props.children);
    }));
});
var TabContent = function (props) {
    var ref = React.useRef(null);
    var isLoaded = React.useRef(false);
    var isAutoScrollFocus = useTabsContext().isAutoScrollFocus;
    // scrollIntoView when selected
    React.useEffect(function () {
        var _a;
        if (!isAutoScrollFocus)
            return;
        if (!isLoaded.current) {
            isLoaded.current = true;
            return;
        }
        if (((_a = ref === null || ref === void 0 ? void 0 : ref.current) === null || _a === void 0 ? void 0 : _a.scrollIntoView) && props.selected) {
            try {
                ref.current.scrollIntoView({
                    behavior: 'smooth',
                    block: 'nearest',
                    inline: 'center',
                });
            }
            catch (error) {
                ref.current.scrollIntoView(false);
            }
        }
    }, [props.selected, isAutoScrollFocus]);
    return (React.createElement("div", { className: styles.content, ref: ref }, props.children));
};

var TabList = React.forwardRef(function (props, ref) {
    var className = props.className, children = props.children, withBorder = props.withBorder, tabListProps = __rest(props, ["className", "children", "withBorder"]);
    var classes = clsx(styles.tabList, withBorder && styles.withBorder, className);
    return (React.createElement(Tab$1.List, __assign({ ref: ref, className: classes, as: "div" }, tabListProps), children));
});

var TabPanels = React.forwardRef(function (props, ref) {
    var className = props.className, children = props.children, tabPanelsProps = __rest(props, ["className", "children"]);
    return (React.createElement(Tab$1.Panels, __assign({ ref: ref, className: className, as: "div" }, tabPanelsProps), children));
});

var TabPanel = React.forwardRef(function (props, ref) {
    var className = props.className, children = props.children, tabPanelProps = __rest(props, ["className", "children"]);
    return (React.createElement(Tab$1.Panel, __assign({ ref: ref, className: className, as: "div" }, tabPanelProps), children));
});

var Tabs = React.forwardRef(function (_a, ref) {
    var children = _a.children, className = _a.className, isFitted = _a.isFitted, _b = _a.defaultIndex, defaultIndex = _b === void 0 ? 0 : _b, _c = _a.manual, manual = _c === void 0 ? true : _c, _d = _a.isAutoScrollFocus, isAutoScrollFocus = _d === void 0 ? true : _d, props = __rest(_a, ["children", "className", "isFitted", "defaultIndex", "manual", "isAutoScrollFocus"]);
    var classes = clsx(styles.tabs, className, isFitted && styles.isFitted);
    return (React.createElement(TabsContextProvider, { value: { isAutoScrollFocus: isAutoScrollFocus } },
        React.createElement(Tab$1.Group, __assign({ as: "div", ref: ref, className: classes, manual: manual, defaultIndex: defaultIndex }, props), children)));
});

export { Tab, TabList, TabPanel, TabPanels, Tabs };
